import { LOADING } from "../actionType/commonType";
import { REGISTER_USER } from "../actionType/signUpType";
import {
  activateAccountUrl,
  azureSignup,
  changeEmailUrl,
  googleSignup,
  resendEmailUrl,
  signUpUrl,
  validateUser,
} from "../constant/Constant";
import { getMethod, postMethod } from "../services/HttpServices";

export const userRegister = (payload) => (dispatch) => {
  dispatch({
    type: LOADING,
    payload: { register: true },
  });
  return postMethod(signUpUrl, payload)
    .then((res) => {
      dispatch({
        type: REGISTER_USER,
        payload: { data: res.data, statusCode: res.status },
      });
      dispatch({
        type: LOADING,
        payload: { register: false },
      });
      return res;
    })
    .catch((err) => {
      dispatch({
        type: LOADING,
        payload: { register: false },
      });
      return err.response.data;
    });
};

export const googleRegister = (payload) => (dispatch) => {
  dispatch({
    type: LOADING,
    payload: { register: true },
  });
  return postMethod(googleSignup, payload)
    .then((res) => {
      dispatch({
        type: LOADING,
        payload: { register: false },
      });
      return res;
    })
    .catch((err) => {
      dispatch({
        type: LOADING,
        payload: { register: false },
      });
      return err.response.data;
    });
};

export const outlookRegister = (payload) => (dispatch) => {
  dispatch({
    type: LOADING,
    payload: { register: true },
  });
  return postMethod(azureSignup, payload)
    .then((res) => {
      dispatch({
        type: LOADING,
        payload: { register: false },
      });
      return res;
    })
    .catch((err) => {
      dispatch({
        type: LOADING,
        payload: { register: false },
      });
      return err.response.data;
    });
};

export const activateAccount = (payload) => (dispatch) => {
  return postMethod(activateAccountUrl, payload)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const resentOtp = (payload) => (dispatch) => {
  return postMethod(resendEmailUrl, payload)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const changeEmail = (payload) => (dispatch) => {
  return postMethod(changeEmailUrl, payload)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const getUserByEmail = (payload) => (dispatch) => {
  return getMethod(`${validateUser}?email=${payload.email}`)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};
